import { Outlet, NavLink, Navigate, Link } from "react-router-dom";
import { useAdminAuth } from "./AdminAuthContext";
import { LogOut, LayoutDashboard, Wrench, Newspaper, Award, Inbox, ExternalLink } from "lucide-react";

const items = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "admin-nav-dashboard" },
  { to: "/admin/equipos", label: "Equipos", icon: Wrench, testid: "admin-nav-equipos" },
  { to: "/admin/blog", label: "Blog", icon: Newspaper, testid: "admin-nav-blog" },
  { to: "/admin/casos", label: "Casos de éxito", icon: Award, testid: "admin-nav-casos" },
  { to: "/admin/contactos", label: "Contactos", icon: Inbox, testid: "admin-nav-contactos" },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAdminAuth();
  if (loading) return <div className="min-h-screen bg-black text-white flex items-center justify-center">Cargando...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-[#0a0a0c] text-white flex">
      <aside className="w-64 shrink-0 border-r border-white/10 flex flex-col">
        <div className="p-6 border-b border-white/10">
          <img src="/asirox-logo.png" alt="Asirox" className="h-8 w-auto"/>
          <p className="text-xs text-white/50 mt-2 font-mono">BACKOFFICE</p>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {items.map((it) => (
            <NavLink
              key={it.to} to={it.to} end={it.end}
              data-testid={it.testid}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 text-sm transition ${
                isActive ? "bg-[#ff9c00] text-black font-bold" : "text-white/70 hover:text-white hover:bg-white/5"
              }`}
            >
              <it.icon size={16}/>{it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-3">
          <Link to="/" target="_blank" data-testid="admin-view-site" className="flex items-center gap-2 text-xs text-white/60 hover:text-[#ff9c00]">
            <ExternalLink size={12}/> Ver web pública
          </Link>
          <div className="text-xs text-white/40 truncate">{user.email}</div>
          <button onClick={logout} data-testid="admin-logout" className="w-full flex items-center justify-center gap-2 border border-white/15 py-2 text-sm hover:border-red-400 hover:text-red-400">
            <LogOut size={14}/> Cerrar sesión
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto p-8">
        <Outlet />
      </main>
    </div>
  );
}
